import { instance } from "../axios"
import type { AxiosRequestConfig } from "axios"


// 取得用戶資訊
export function getAccountInfo(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/accounts/current/",
        method: "get",
        ...config,
    })
}

// 取得用戶權限
export function getAccountPermission(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/accounts/current/permissions/`,
        method: "get",
        ...config,
    })
}

// 取得用戶消息顯示設定
export function getAccountNotificationSettings(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/accounts/current/notification-settings/`,
        method: "get",
        ...config,
    })
}

// 更新用戶消息顯示設定
export function updateAccountNotificationSettings(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/accounts/current/notification-settings/`,
        method: "put",
        ...config,
    })
}

// 取得用戶通知計數
export function getAccountNotificationCounter(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/accounts/current/notification-counter/`,
        method: "get",
        ...config,
    })
}
